import Footer from "../HomePage/footer";
import Header from "../HomePage/header";

const PrivacyPolicyPage = () => {
  return (
    <>
      <Header />
      <div
        className="h-[150px] w-full bg-cover bg-center bg-no-repeat md:h-[350px]"
        style={{
          backgroundImage: `
      linear-gradient(
        270deg,
        rgba(255, 255, 255, 0) 10.52%,
        rgba(34, 55, 51, 0.56) 51.88%,
        rgba(18, 46, 41, 0.94) 100%
      ),
      url('/assets/privacy-policy-banner.png')
    `,
        }}
      >
        <div className="container mx-auto h-full px-4 md:px-0">
          <div className="flex h-full items-center">
            <h1 className="font-nunito text-[20px] font-bold text-white md:text-[40px]">
              Privacy Policy
            </h1>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-5 md:px-0 md:py-10">
        <div className="">
          <h2 className="font-nunito text-[20px] font-bold text-[#2F363F]">
            1. Introduction
          </h2>
          <p className="mt-3 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            Monarch Networth Capital Ltd. (“we”, “our”, or “us”) operates the
            MNCL digital platforms (“Portal”). We are committed to protecting
            your personal data and respecting your privacy. This Privacy Policy
            describes how we collect, use, disclose, store, and protect your
            personal data under the Digital Personal Data Protection Act, 2023.
          </p>
        </div>

        <div className="mt-3 md:mt-6">
          <h2 className="font-nunito text-[20px] font-bold text-[#2F363F]">
            2. Data Fiduciary & Contact Information
          </h2>
          <p className="mt-3 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            - Data Fiduciary : Monarch Networth Capital Ltd.
          </p>
          <p className="mt-1 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            - Website : https://www.mnclgroup.com/
          </p>
          <p className="mt-1 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            - Grievance Officer : [Name], Email: [Email], Contact: [Phone]{" "}
          </p>
        </div>

        <div className="mt-3 md:mt-6">
          <h2 className="font-nunito text-[20px] font-bold text-[#2F363F]">
            3. What Personal Data We Collect
          </h2>
          <p className="mt-3 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            - Identity data: Name, DOB, PAN (masked), Aadhaar (masked), Bank
            details, etc.
          </p>
          <p className="mt-1 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            - Contact data: Mobile number, email ID.
          </p>
          <p className="mt-1 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            - Financial data: Transactions, contribution history, portfolio
            details.
          </p>
          <p className="mt-1 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            - Transaction data: Payment history, contribution amounts, etc.
          </p>
          <p className="mt-1 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            - Technical data: IP address, device/browser details, login logs.
          </p>
          <p className="mt-1 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            - Sensitive personal data: Aadhaar, PAN, bank details.
          </p>
        </div>

        <div className="mt-3 md:mt-6">
          <h2 className="font-nunito text-[20px] font-bold text-[#2F363F]">
            4. Purpose of Processing
          </h2>
          <p className="mt-3 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            We process personal data to:
          </p>
          <p className="mt-1 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            - Provide MNCL digital services and account operations.
          </p>
          <p className="mt-1 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            - Comply with PFRDA and regulatory obligations.
          </p>
          <p className="mt-1 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            - Improve, secure and audit the Portal.
          </p>
        </div>

        <div className="mt-3 md:mt-6">
          <h2 className="font-nunito text-[20px] font-bold text-[#2F363F]">
            5. Data Sharing
          </h2>
          <p className="mt-3 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            We may share data with:
          </p>
          <p className="mt-1 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            - Regulatory bodies including PFRDA.
          </p>
          <p className="mt-1 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            - CRA entities as required.
          </p>
          <p className="mt-1 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            - Service providers under strict confidentiality.
          </p>
        </div>

        <div className="mt-3 md:mt-6">
          <h2 className="font-nunito text-[20px] font-bold text-[#2F363F]">
            6. Data Retention
          </h2>
          <p className="mt-3 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            We retain personal data only as long as required for lawful purposes
          </p>
        </div>

        <div className="mt-3 md:mt-6">
          <h2 className="font-nunito text-[20px] font-bold text-[#2F363F]">
            7. Your Rights
          </h2>
          <p className="mt-3 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            You have the right to:
          </p>
          <p className="mt-1 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            - Access, correct, update and erase your data.
          </p>
          <p className="mt-1 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            - Withdraw consent.
          </p>
          <p className="mt-1 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            - Complain to the Data Protection Board.
          </p>
        </div>

        <div className="mt-3 md:mt-6">
          <h2 className="font-nunito text-[20px] font-bold text-[#2F363F]">
            8. Security Measures
          </h2>
          <p className="mt-3 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            AES‑256 encryption, TLS-1.2+, RBAC, audit logs, VAPT, secure
            backups.
          </p>
        </div>

        <div className="mt-3 md:mt-6">
          <h2 className="font-nunito text-[20px] font-bold text-[#2F363F]">
            9. Changes to Policy
          </h2>
          <p className="mt-3 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            We may update this policy periodically.
          </p>
        </div>

        <div className="mt-3 md:mt-6">
          <h2 className="font-nunito text-[20px] font-bold text-[#2F363F]">
            10. Contact
          </h2>
          <p className="mt-3 font-nunito text-[18px] font-medium text-[#3C3C4399]">
            For DPDP requests, contact our Grievance Officer.{" "}
          </p>
        </div>
      </div>

      <Footer />
    </>
  );
};

<p className="mt-1 font-nunito text-[18px] font-medium text-[#3C3C4399]">
  - Consent: When you provide explicit consent for specific data sharing.
</p>;
export default PrivacyPolicyPage;
